class Accordion {
  public items: HTMLCollection;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          item.classList.toggle('is--active');
          (item.parentElement as HTMLElement).classList.toggle('is-active');
        });
      });
      document.addEventListener('click', (e: MouseEvent) => {
        Object.values(this.items).forEach((item) => {
          const parent = item.parentElement as HTMLElement;
          const target = e.target as HTMLElement;
          if(parent.classList.contains('m-filter')) {
            if(!parent.contains(target)) {
              parent.classList.remove('is-active');
            }
          }
        });
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('js-accordion-toggle');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Accordion;
